// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HEiR","left":"styles_left__1863a"};